<template>
  <button
    v-on="$listeners"
    :class="[
      $style.root,
      $style[kind],
      $style[size],
      loading && 'pointer-events-none'
    ]"
    class="relative px-4 inline-flex items-center justify-between type-scale-n1 focus:outline-none"
  >
    <AppLoading v-if="loading" />
    <template v-else>
      <slot />
      <i class="material-icons ml-4 type-scale-1" v-if="icon">{{ icon }}</i>
    </template>
    <div :class="$style.focusState"></div>
  </button>
</template>

<script>
export default {
  name: 'AppButton',

  props: {
    loading: Boolean,
    icon: String,
    size: {
      type: String,
      default: () => 'md',
      validator: size => ['sm', 'md'].includes(size)
    },
    kind: {
      type: String,
      default: () => 'primary',
      validator: kind => ['primary', 'secondary'].includes(kind)
    }
  }
}
</script>

<style lang="postcss" module>
.primary {
  @apply bg-primary text-white;
}

.primary:hover {
  @apply bg-primary-hover;
}

.primary:active {
  @apply bg-primary-active;
}

.secondary {
  @apply bg-gray-10 text-black;
}

.secondary:hover {
  @apply bg-gray-20;
}

.secondary:active {
  @apply bg-gray-30;
}

.md {
  @apply h-12;
}

.sm {
  @apply h-10;
}

.root:focus .focusState {
  top: 3px;
  left: 3px;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  outline: 2px solid theme('colors.primary.default');
  @apply absolute pointer-events-none border border-white;
}

.root:disabled {
  @apply bg-gray-20 text-gray-40 pointer-events-none cursor-not-allowed;
}
</style>
